import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { apiUrl, getErrorMessage } from '../utils/api';

function Profile() {
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', phoneNumber: '', whatsappNumber: '', whatsappOptIn: false, emailMarketingOptIn: false });
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (!userInfo?.token) {
          navigate('/login');
          return;
        }

        const config = { headers: { Authorization: `Bearer ${userInfo.token}` } };
        const { data } = await axios.get(apiUrl('/api/auth/profile'), config);
        setUser(data);
        setForm({ name: data.name || '', email: data.email || '', phoneNumber: data.phoneNumber || '', whatsappNumber: data.whatsappNumber || '', whatsappOptIn: data.whatsappOptIn === true, emailMarketingOptIn: data.emailMarketingOptIn === true });
      } catch (err) {
        navigate('/login');
      }
    };

    loadProfile();
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');

    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (!userInfo?.token) {
      navigate('/login');
      return;
    }

    setBusy(true);
    try {
      const { data } = await axios.put(apiUrl('/api/auth/profile'), form, {
        headers: { Authorization: `Bearer ${userInfo.token}` },
      });
      localStorage.setItem('userInfo', JSON.stringify(data));
      window.dispatchEvent(new Event('authchange'));
      setUser(data);
      setMessage('Profile updated successfully.');
    } catch (err) {
      setError(getErrorMessage(err, 'Could not update your profile.'));
    } finally {
      setBusy(false);
    }
  };

  if (!user) return <div className="page"><div className="panel">Loading...</div></div>;

  return (
    <div className="page auth-page">
      <form className="panel auth-card profile-page-card" onSubmit={handleSubmit}>
        <p className="eyebrow">Profile</p>
        <h1>Update your account</h1>
        <p className="muted-text">Keep your name and email current. Security actions stay in Quick actions on the dashboard.</p>
        <label>
          Full name
          <input
            type="text"
            value={form.name}
            onChange={(e) => setForm((current) => ({ ...current, name: e.target.value }))}
            placeholder="Your name"
            required
          />
        </label>
        <label>
          Email address
          <input
            type="email"
            value={form.email}
            onChange={(e) => setForm((current) => ({ ...current, email: e.target.value }))}
            placeholder="you@example.com"
            required
          />
        </label>
        <label>
          Phone number
          <input
            type="tel"
            value={form.phoneNumber}
            onChange={(e) => setForm((current) => ({ ...current, phoneNumber: e.target.value }))}
            placeholder="+501 600 0000"
          />
        </label>
        <label>
          WhatsApp number
          <input
            type="tel"
            value={form.whatsappNumber}
            onChange={(e) => setForm((current) => ({ ...current, whatsappNumber: e.target.value }))}
            placeholder="+501 600 0000"
          />
        </label>
                <label className="checkbox-row">
          <input type="checkbox" checked={form.emailMarketingOptIn} onChange={(e) => setForm((current) => ({ ...current, emailMarketingOptIn: e.target.checked }))} />
          <span>I agree to receive occasional email promotions and updates from businesses where I have booked.</span>
        </label>
<label className="checkbox-row">
          <input
            type="checkbox"
            checked={form.whatsappOptIn}
            onChange={(e) => setForm((current) => ({ ...current, whatsappOptIn: e.target.checked }))}
          />
          <span>I agree to receive WhatsApp booking and appointment updates at this number.</span>
        </label>
        <p className="muted-text">Enter a WhatsApp-enabled number and save your profile. WhatsApp updates are sent only when you have opted in and the business has WhatsApp available.</p>
        <button className="button primary" type="submit" disabled={busy}>{busy ? 'Saving…' : 'Save profile'}</button>
        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}
        <p className="muted-text"><Link to="/dashboard">Back to dashboard</Link></p>
      </form>
    </div>
  );
}

export default Profile;
